export const getPeriodOptions = (t) => [
  {
    value: '7',
    label: t('visitors:periods.last7Days'),
  },
  {
    value: '30',
    label: t('visitors:periods.last30Days'),
  },
  {
    value: '60',
    label: t('visitors:periods.last60Days'),
  },
  {
    value: '90',
    label: t('visitors:periods.last90Days'),
  },
]

export const defaultPeriodValue = '30'
